import { Stack, Typography } from '@mui/material'
import { ListItem, useTheme } from '@mui/material'
import { IBroadcastChatListItem } from '@/utils/zod/broadcastChatSchema';
import MmsOutlinedIcon from '@mui/icons-material/MmsOutlined';
import { DateField } from '@refinedev/mui';
import { CustomCheckbox } from '../override';
import SareeIcon from '@/assests/icons/SareeIcon';
import palette from '@/palette';

export const ChatlistItem = ({ 
  chat,
  isSelected,
  onSelect,
  allowCheckbox = false
}: { 
  chat: IBroadcastChatListItem;
  isSelected: boolean;
  onSelect: (id: string) => void;
  allowCheckbox: boolean;
}) => {

  const theme = useTheme();
  return (
    <ListItem
      component="button"
      onClick={() => onSelect(chat.id)}
      sx={{
        border: 'none',
        borderBottom: `1px solid ${theme.palette.divider}`,
        "&:hover": { backgroundColor: isSelected 
            ? theme.palette.action.focus 
            : theme.palette.action.hover 
        },
        padding: 1,
        paddingInline: 2,
        backgroundColor: isSelected ? theme.palette.action.selected : 'inherit',
        height: 84,
      }}
    >
        {allowCheckbox && <CustomCheckbox
            checked={isSelected}
            onChange={() => onSelect(chat.id)}
            sx={{
                marginRight: 2,
            }}
        />}
        <Stack direction="column" width="100%" spacing={0.5} >
            <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
                <Typography variant="subtitle1" fontWeight="medium" fontSize={18} textOverflow="ellipsis" overflow="hidden" whiteSpace="nowrap" sx={{ color: theme.palette.text.primary }}>
                    {chat.name}
                </Typography>
                
                {chat.last_message?.server_received_at && (
                    <Typography
                        variant="caption"
                        sx={{ marginLeft: 2, color: theme.palette.text.secondary }}
                    >
                        <DateField value={chat.last_message.server_received_at} format={Math.abs((new Date).getTime() - (new Date(chat.last_message.server_received_at)).getTime()) / 3600000 < 24 ? "hh:mm a" : "MMM DD"} />
                    </Typography>
                )}
            </Stack>
            <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
                {chat.last_message ? 
                <Typography variant="caption" fontWeight="light" sx={{ color: theme.palette.text.secondary }} fontSize={14} textOverflow="ellipsis" overflow="hidden" whiteSpace="nowrap">
                    {chat.last_message?.text ? (
                        chat.last_message.text.length > 30 ? chat.last_message.text.slice(0, 30) + "..." : chat.last_message.text
                    ) : chat.last_message?.products?.length && JSON.parse(chat.last_message?.products).length > 0 ? (
                        <Stack direction="row" alignItems="center">
                            <SareeIcon sx={{ marginRight: 0.5, color: theme.palette.mode === 'dark' ? palette.dark.grey[300] : palette.light.grey[600] }} />
                            {JSON.parse(chat.last_message?.products).length} Products
                        </Stack>
                    ) : (
                        <Stack direction="row" alignItems="center">
                            <MmsOutlinedIcon sx={{ marginRight: 0.5 }} />
                            {chat.last_message?.format === "video" ? "Video" : "Image"}
                        </Stack>
                    )}
                </Typography> : 
                <Typography variant="caption" fontWeight="light" sx={{ color: theme.palette.text.secondary, fontStyle: 'italic' }} fontSize={14} textOverflow="ellipsis" overflow="hidden" whiteSpace="nowrap">
                    No messages yet
                </Typography>}
            </Stack>
        </Stack>
    </ListItem>
  )
}